import { Skeleton } from "baseui/skeleton";

export default function TableLoader({...props}) {
  return <Skeleton width="100%" height="auto" animation {...props} />;
}
